module.exports = {
          srcSet: __webpack_public_path__ + "d8737e94d196b363821c160a17069c9f-63.png"+" 63w",
          images:[ {path: __webpack_public_path__ + "d8737e94d196b363821c160a17069c9f-63.png",width: 63,height: 72}],
          src: __webpack_public_path__ + "d8737e94d196b363821c160a17069c9f-63.png",
          toString:function(){return __webpack_public_path__ + "d8737e94d196b363821c160a17069c9f-63.png"},
          
          width: 63,
          height: 72
        }